module.exports = __webpack_public_path__ + "static/media/img_cal5.6b3421be.jpg";